export const STATE_NAME = 'payoutsMultiBilling';

export const REMOVE_COMMA_REGEX = new RegExp(/(,)(.)$/);
